<template>
  <div v-if="isActive" class="dynamic-component">
    <div class="content">
      <div class="icon" @click="isActive = !isActive">
        <img src="../assets/lucide_x.d7f63b4d.svg" />
      </div>
      <div class="end_box code_box">
        <div class="img" style="width: 50%">
          <img alt="" src="../assets/image_195.85646f1a.svg" />
        </div>
        <div class="time_tip">
          剩余时间:<span class="time">
            {{ countdown }}
          </span>
        </div>
        <div class="end_tip">订单尚未完成</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from "vue";

const targetTimestamp = ref(0);

const isActive = ref(true);
const remainingTime = ref(targetTimestamp.value - new Date().getTime());
const countdown = ref("");

function formatTime(ms: number): string {
  const seconds = String(Math.floor(ms / 1000) % 60).padStart(2, "0");
  const minutes = String(Math.floor(ms / (1000 * 60)) % 60).padStart(2, "0");
  const hours = String(Math.floor(ms / (1000 * 60 * 60)) % 24).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}

function updateCountdown() {
  remainingTime.value = targetTimestamp.value - new Date().getTime();
  if (remainingTime.value <= 0) {
    countdown.value = "倒计时结束！";
    isActive.value = false;
  } else {
    countdown.value = formatTime(remainingTime.value);
  }
}

let interval: ReturnType<typeof setInterval>;

onMounted(() => {
  interval = setInterval(updateCountdown, 1000);
  targetTimestamp.value = Number(localStorage.getItem("expirationTimestamp"));

  updateCountdown();
});

onBeforeUnmount(() => {
  clearInterval(interval);
});
</script>

<style lang="scss" scoped>
.dynamic-component {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;

  .content {
    width: 25%;
    background-color: rgb(24, 24, 27);
    padding: 30px;
    border-radius: 16px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.1),
      0 5px 5px 0 rgba(0, 0, 0, 0.1), 0 11px 11px 0 rgba(0, 0, 0, 0.1),
      inset 0 1px 0 0 hsla(0, 0%, 100%, 0.03),
      inset 0 0 0 1px hsla(0, 0%, 100%, 0.03);
    position: relative;
  }

  .time_tip {
    font-size: 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .time {
    color: #9dff7b !important;
  }

  .end_box {
    .pay_sub {
      width: 100% !important;
    }

    .img {
      width: 330px;
      margin: auto;
      margin-bottom: 20px;

      img {
        width: 100%;
      }
    }

    .end_tip {
      width: 60%;
      margin: auto;
      margin-top: 52px;
      font-size: 14px;
      color: #fff;
      text-align: center;
    }
  }

  .icon {
    width: 32px;
    height: 32px;
    margin-left: 10px;
    cursor: pointer;
    position: absolute;
    top: 5%;
    right: 5%;

    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
